import { mapGetters } from "vuex";
import { hasPermission, hasMultiplePermission } from "@/store/modules/auth";
import { ROLES, PERMISSIONS } from "@/utils/constant";

export const PermissionMixin = {
  data() {
    return {
      ROLES,
      PERMISSIONS,
    };
  },
  computed: {
    ...mapGetters(["userInfo"]),
    isSupAdmin() {
      return this.userInfo.role === this.ROLES.SUPER_ADMIN;
    },
    isSalesPerson() {
      return this.userInfo.role === this.ROLES.SALES_PERSON;
    },
    isSalesManager() {
      return this.userInfo.role === this.ROLES.SALES_MANAGER;
    },
    isPickingSupervisor() {
      return this.userInfo.role === this.ROLES.PICKING_SUPERVISOR;
    },
    isPicker() {
      return this.userInfo.role === this.ROLES.PICKER;
    },
    isDispatchSupervisor() {
      return this.userInfo.role === this.ROLES.DISPATCH_SUPERVISOR;
    },
    isDispatcher() {
      return this.userInfo.role === this.ROLES.DISPATCHER;
    },
    isAccounting() {
      return this.userInfo.role === this.ROLES.ACCOUNTING;
    },
    isInventoryPerson() {
      return this.userInfo.role === this.ROLES.INVENTORY_PERSON;
    },
    canSellItem() {
      return this.isSupAdmin || this.isSalesPerson || this.isSalesManager;
    },
    canViewAllInvoice() {
      return (
        this.isSupAdmin ||
        this.isPicker ||
        this.isDispatcher ||
        this.isPickingSupervisor ||
        this.isDispatchSupervisor ||
        this.isAccounting ||
        this.isSalesManager
      );
    },
  },
  methods: {
    hasPermission(permission) {
      return hasPermission(permission);
    },
    hasMultiplePermission(permissions) {
      return hasMultiplePermission(permissions);
    },
  },
};
